import React, { useRef } from 'react';
import classNames from 'classnames';

import { SvgIcon } from '../../../design-system';
import { More2FillIcon } from '../../../design-system/Icons';
import ArrowRightSLineIcon from '../../../design-system/Icons/ArrowRightSLineIcon';

const FolderBreadcrumbItem = ({
    item,
    index,
    folderId,
    isHidden,
    setIsFullLocationDisplayed,
    handleItemClick,
    moreOptionsPopup,
    openMoreOptionsPopup,
}) => {
    const buttonRef = useRef(null);

    if (isHidden) {
        return (
            <button
                onClick={() => setIsFullLocationDisplayed(true)}
                className="flex items-center gap-1 whitespace-nowrap outline-0 focus:outline-none"
            >
                <p className="font-body-medium text-body-regular-xs text-neutral-300">...</p>
                <ArrowRightSLineIcon width={10} height={10} color="#5E6470" />
            </button>
        );
    }

    const { id, label } = item;

    const handleMoreOptionsClick = () => {
        const data = { id, label };
        const buttonRect = buttonRef.current?.getBoundingClientRect();

        openMoreOptionsPopup({ data, buttonRect });
    };

    const isCurrentFolder = id === folderId;
    const labelClassName = isCurrentFolder
        ? 'font-body-medium text-body-regular-s text-neutral-500'
        : 'font-body-medium text-body-regular-xs text-neutral-300';

    const moreOptionsButtonClassName = classNames(
        'pr-3 focus:outline-0 block lg:group-hover:block',
        {
            'lg:hidden': !moreOptionsPopup,
            'lg:block': moreOptionsPopup,
        }
    );

    return (
        <div className="group flex items-center gap-1 whitespace-nowrap">
            <button
                onClick={() => handleItemClick(id, index)}
                className="flex items-center gap-1 whitespace-nowrap outline-0 focus:outline-none"
            >
                <p className={labelClassName}>{label}</p>
                {!isCurrentFolder && <ArrowRightSLineIcon width={10} height={10} color="#5E6470" />}
            </button>

            {isCurrentFolder && (
                <div className="relative">
                    <button
                        ref={buttonRef}
                        className={moreOptionsButtonClassName}
                        onClick={handleMoreOptionsClick}
                    >
                        <SvgIcon color="#000000" icon={More2FillIcon} size="medium" />
                    </button>
                </div>
            )}
        </div>
    );
};

export default FolderBreadcrumbItem;
